import { MDCSimpleMenu } from '@material/menu/dist/mdc.menu';
import { initMDCRipples } from './ripple';

/**
 * Init MDC Simple Menus and their toggles.
 * 
 * @link https://github.com/material-components/material-components-web/tree/v0.28.0/master/packages/mdc-menu
 *
 * @since 0.0.1
 * @return {void} 
 */
export function initMDCSimpleMenu(menu, startOpen = false) {
	if (menu) {
		const MDCSimpleMenuInst = new MDCSimpleMenu(menu);
		if (startOpen) {
			MDCSimpleMenuInst.open = true;
		}
		// listen for events.
		MDCSimpleMenuInst.listen('MDCSimpleMenu:selected', (e) => {
			menu.setAttribute('aria-expanded', false);
		});
		MDCSimpleMenuInst.listen('MDCSimpleMenu:cancel', (e) => {
			menu.setAttribute('aria-expanded', false);
		});
		// init toggles
		const toggles = document.querySelectorAll('*[aria-controls="' + menu.id + '"]');
		toggles.forEach((toggle, i) => {
			toggle.addEventListener('click', (e) => {
				e.preventDefault();
				MDCSimpleMenuInst.open = true;
				menu.setAttribute('aria-expanded', true);
				initMDCRipples(menu, 250);
			});
		});
	}
}

export function initMDCSimpleMenus() {
	const menus = document.querySelectorAll('.mdc-simple-menu');
	menus.forEach((menu, i) => {
		initMDCSimpleMenu(menu);
	});
}